// extracted by mini-css-extract-plugin
export default {"card":"index_card__yMcR5","tag":"index_tag__HTZav","hidden":"index_hidden__dm6a8","blur-bg":"index_blur-bg__bC6xL"};